module.exports = __webpack_public_path__ + "static/media/cornwall1-mobile.885156f7.jpg";